import classnames from 'classnames';
import { SpinnerGap } from 'phosphor-react';
import { forwardRef } from 'react';
import type { IconComponent } from './types';

export const LoadingSpinner: IconComponent = forwardRef(({ className, size = 16 }, ref) => (
  <span>
    <SpinnerGap ref={ref} role="status" className={classnames('animate-spin text-medium-shade', className)} size={size} />
    <span className="sr-only">Loading...</span>
  </span>
));

export default LoadingSpinner;
